import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, X, MapPin } from 'lucide-react';
const buyers = [{
  name: 'Sofía G.',
  city: 'La Plata, Buenos Aires'
}, {
  name: 'Martín L.',
  city: 'Mendoza'
}, {
  name: 'Lucía A.',
  city: 'Mar del Plata'
}, {
  name: 'Joaquín P.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Valentina R.',
  city: 'Rosario, Santa Fe'
}, {
  name: 'Diego S.',
  city: 'Salta'
}, {
  name: 'Florencia M.',
  city: 'Neuquén'
}, {
  name: 'Tomás B.',
  city: 'Bahía Blanca'
}, {
  name: 'Agustina C.',
  city: 'Córdoba Capital'
}, {
  name: 'Federico D.',
  city: 'Resistencia, Chaco'
}, {
  name: 'Camila V.',
  city: 'San Juan'
}, {
  name: 'Nicolás H.',
  city: 'Posadas, Misiones'
}, {
  name: 'Julieta T.',
  city: 'CABA'
}, {
  name: 'Bruno E.',
  city: 'Río Cuarto, Córdoba'
}, {
  name: 'Micaela O.',
  city: 'Santa Fe'
}, {
  name: 'Lucas N.',
  city: 'Paraná, Entre Ríos'
}, {
  name: 'Romina F.',
  city: 'Quilmes, Buenos Aires'
}, {
  name: 'Ezequiel J.',
  city: 'San Luis'
}, {
  name: 'Carolina P.',
  city: 'Bariloche'
}, {
  name: 'Mauro A.',
  city: 'Tigre, Buenos Aires'
}];
const offers = ['el Megapack Entrena en Casa™ + 3 Bonus', 'el sistema Entrena en Casa™ Completo'];
const timeAgoOptions = ['hace 2 minutos', 'hace 5 minutos', 'hace 7 minutos', 'hace 1 minuto', 'hace unos segundos', 'hace 12 minutos', 'hace 3 minutos'];
interface Notification {
  id: number;
  name: string;
  city: string;
  offer: string;
  timeAgo: string;
}
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function randomInRange(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function PurchasePopup() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const triggerNotification = useCallback(() => {
    setNotification({
      id: Date.now(),
      name: pick(buyers).name,
      city: pick(buyers).city,
      offer: pick(offers),
      timeAgo: pick(timeAgoOptions)
    });
  }, []);
  useEffect(() => {
    // First notification after a small delay so the page can load
    const firstTimer = setTimeout(() => {
      triggerNotification();
    }, 8000);
    return () => clearTimeout(firstTimer);
  }, [triggerNotification]);
  useEffect(() => {
    if (!notification) return;
    // Hide current notification after 6s
    const hideTimer = setTimeout(() => {
      setNotification(null);
    }, 6000);
    // Schedule the next one between 40-60s after this one appears
    const nextDelay = randomInRange(40000, 60000);
    const nextTimer = setTimeout(() => {
      triggerNotification();
    }, nextDelay);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [notification, triggerNotification]);
  return <div aria-live="polite" aria-atomic="true" className="fixed bottom-24 left-4 z-[60] md:bottom-6 md:left-6 pointer-events-none" data-id="element-228">
      <AnimatePresence data-id="element-229">
        {notification && <motion.div key={notification.id} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 24
      }} className="pointer-events-auto bg-dark-card/95 backdrop-blur-md border border-brand/40 rounded-xl shadow-[0_10px_40px_rgba(0,0,0,0.5)] p-3 pr-8 flex items-start gap-3 max-w-[320px] relative" data-id="element-230">
            <button onClick={() => setNotification(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-231">
              <X className="w-3.5 h-3.5" data-id="element-232" />
            </button>

            <div className="shrink-0 w-9 h-9 rounded-full bg-brand/15 border border-brand/40 flex items-center justify-center" data-id="element-233">
              <CheckCircle2 className="w-5 h-5 text-brand" data-id="element-234" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-235">
              <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-brand mb-0.5" data-id="element-236">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-237" />
                Compra verificada
              </div>
              <p className="text-sm text-white leading-snug" data-id="element-238">
                <span className="font-bold" data-id="element-239">{notification.name}</span>
                <span className="text-gray-300" data-id="element-240"> compró </span>
                <span className="font-bold text-brand" data-id="element-241">
                  {notification.offer}
                </span>
              </p>
              <div className="flex items-center gap-2 mt-1 text-[11px] text-gray-400" data-id="element-242">
                <span className="inline-flex items-center gap-1" data-id="element-243">
                  <MapPin className="w-3 h-3" data-id="element-244" />
                  {notification.city}
                </span>
                <span className="text-gray-600" data-id="element-245">·</span>
                <span data-id="element-246">{notification.timeAgo}</span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}